import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";

import {
  GET_DEBRIEF_ANALYTICS_PENDING,
  GET_DEBRIEF_ANALYTICS,
  SG_GET_DEBRIEF_ANALYTICS,
  DELETE_DEBRIEF_ANALYTICS,
  SG_DELETE_DEBRIEF_ANALYTICS,
  FETCH_DEBRIEF_ANALYTICS,
  SG_FETCH_DEBRIEF_ANALYTICS,
  EDIT_DEBRIEF_ANALYTICS,
  SG_EDIT_DEBRIEF_ANALYTICS,
  ADD_DEBRIEF_ANALYTICS,
  SG_ADD_DEBRIEF_ANALYTICS,
  ALL_ERRORS,
} from "constants/actions";
import { handleError } from "./ApiError";

function* loadmethods(action) {
    yield put({ type: GET_DEBRIEF_ANALYTICS_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_DEBRIEF_ANALYTICS, action.payload);
    yield put({ type: GET_DEBRIEF_ANALYTICS, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodLoad() {
  yield takeLatest(SG_GET_DEBRIEF_ANALYTICS, loadmethods);
}

function* fetchmethods(action) {
  yield put({ type: GET_DEBRIEF_ANALYTICS_PENDING });
  try {
    const json = yield call(api.FETCH_DEBRIEF_ANALYTICS, action.payload);
    yield put({ type: FETCH_DEBRIEF_ANALYTICS, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_DEBRIEF_ANALYTICS, fetchmethods);
}

function* updatemethods(action) {
  yield put({ type: GET_DEBRIEF_ANALYTICS_PENDING });
  try {
    const json = yield call(api.EDIT_DEBRIEF_ANALYTICS, action.payload);
    yield put({ type: EDIT_DEBRIEF_ANALYTICS, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodUpdate() {
  yield takeLatest(SG_EDIT_DEBRIEF_ANALYTICS, updatemethods);
}


function* addmethods(action) {
  yield put({ type: GET_DEBRIEF_ANALYTICS_PENDING });
  try {
    const json = yield call(api.ADD_DEBRIEF_ANALYTICS, action.payload);
    yield put({ type: ADD_DEBRIEF_ANALYTICS, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_DEBRIEF_ANALYTICS, addmethods);
}

function* deletemethods(action) {
  yield put({ type: GET_DEBRIEF_ANALYTICS_PENDING });
  try {
    yield call(api.DELETE_DEBRIEF_ANALYTICS, action.payload);
    yield put({ type: DELETE_DEBRIEF_ANALYTICS, payload: action.payload });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_DEBRIEF_ANALYTICS, deletemethods);
}


export default function* index() {
  yield all([
    methodLoad(),
    methodFetch(),
    methodUpdate(),
    methodAdd(),
    methodDelete(),
  ]);
}
